import ThemeProvider from '@zegal/components/src/base/src/common/wrapThemeProvider';

export const WrapThemeProvider = ThemeProvider;
